<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "campaign",
  data() {
    return {};
  },
  created() {}
};
</script>
